import { CampaignStatus } from '../types/campaign';

/**
 * Array of all valid campaign status values.
 * Used for filtering and dropdown options.
 */
export const CAMPAIGN_STATUSES: readonly CampaignStatus[] = Object.freeze([
  'Review',
  'Approve',
  'Draft',
  'Hold',
  'Pending',
  'Revise',
  'Scheduled',
  'Running',
  'Completed',
  'Cancelled',
] as const);

/**
 * Map of uppercase status keys to their display values.
 * Used for consistent status lookups across the application.
 */
export const CAMPAIGN_STATUSES_MAP: Record<string, CampaignStatus> = Object.freeze({
  REVIEW: 'Review',
  APPROVE: 'Approve',
  DRAFT: 'Draft',
  HOLD: 'Hold',
  PENDING: 'Pending',
  REVISE: 'Revise',
  SCHEDULED: 'Scheduled',
  RUNNING: 'Running',
  COMPLETED: 'Completed',
  CANCELLED: 'Cancelled',
} as const);
